function equalHeight() {
  var columns = document.querySelectorAll('.equalHeightColumn');
  if (columns.length === 0) return; // Exit if no elements found

  var maxHeight = 0;

  // Reset height to auto before recalculating
  columns.forEach(function(column) {
    column.style.height = 'auto';
  });

  // Find the maximum height
  columns.forEach(function(column) {
    var columnHeight = column.offsetHeight; // Get element height
    if (columnHeight > maxHeight) {
      maxHeight = columnHeight;
    }
  });

  // Apply max height to all columns
  columns.forEach(function(column) {
    column.style.height = maxHeight + 'px';
  });
}

// Run the function after the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  equalHeight();
  window.addEventListener('resize', equalHeight); // Recalculate on window resize

});

function initializeParallax() {
  document.addEventListener("DOMContentLoaded", function () {
    const containers = document.querySelectorAll("[data-section-id]");
    if (!containers.length) return;

    containers.forEach((container) => {
      const id = container.getAttribute("data-section-id");
      const featuredImage = document.getElementById("FeaturedImage-" + id);
      if (!featuredImage) return;

      const parallaxSrc = featuredImage.getAttribute("data-parallax-src");
      if (!parallaxSrc) return;

      // Create a parallax mirror element
      const parallaxMirror = document.createElement("div");
      parallaxMirror.classList.add("parallax-mirror");
      parallaxMirror.style.position = "fixed";
      parallaxMirror.style.top = "0";
      parallaxMirror.style.left = "0";
      parallaxMirror.style.overflow = "hidden";
      parallaxMirror.style.zIndex = "-100";
      featuredImage.appendChild(parallaxMirror);
      
      // Create and append parallax image inside mirror
      const parallaxImage = document.createElement("img");
      parallaxImage.classList.add("parallax-slider", "lazyautosizes", "lazyloaded");
      parallaxImage.src = parallaxSrc;
      parallaxImage.style.position = "absolute";
      parallaxImage.style.maxWidth = "none";
      parallaxMirror.appendChild(parallaxImage);

      function updateParallax() {
        const rect = featuredImage.getBoundingClientRect();
        const scrollY = window.scrollY;
        const speed = 0.3;
        const yPos = (scrollY - rect.top) * speed;

        parallaxMirror.style.width = window.innerWidth + "px";
        parallaxMirror.style.height = rect.height + "px";
        parallaxImage.style.width = window.innerWidth + "px";
        parallaxImage.style.height = rect.height * 1.5 + "px";
        parallaxImage.style.transform = `translate3d(0px, ${yPos}px, 0px)`;
      }
      
      window.addEventListener("scroll", updateParallax);
      window.addEventListener("resize", updateParallax);
      updateParallax(); // Apply on load
    });
  });
}

initializeParallax();

/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

/*
(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
*/
